/* VINYLPAC Bulk Order Form. The engine owns measuring, prices and checkout. */
(function () {
  'use strict';
  const C = window.VPBulkCart;
  const $ = (id) => document.getElementById(id);
  const form = $('bulkForm'), list = $('bulkRows');
  if (!C) { $('saveStatus').textContent = 'The form could not load. Please refresh.'; return; }
  const money = (cents) => '$' + (Number(cents || 0) / 100).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2});
  const num = (n) => Number(n) > 0 ? String(Math.round(Number(n) * 100) / 100) : '';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const today = () => { const d = new Date(); return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0'); };
  const id = () => 'design-' + (window.crypto?.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2));
  const artIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M12 16V3m-5 5 5-5 5 5M4 15v5h16v-5"/></svg>';
  let rows = [], metas = new Map(), defaults = {material:'',laminate:'',cut:'',value:'',side:'h',qty:''};
  let hydrated = false, checkingOut = false, checked = false, pickerOpen = null, rowFileTarget = null;
  let saveTimer, saveChain = Promise.resolve(), stopSaving = false, storageFailed = false, revision = 0;
  let measuring = 0, measureQueue = [], unfreezeCheckout = null;
  const pickerRegistry = new Map(), priceTimers = new Map();

  // WebKit can reject File/Blob values in IndexedDB. Store original bytes once per file;
  // editing the form only writes small metadata. Recreate real Files when a draft opens.
  const fileKeys=new WeakMap(),savedFiles=new Set();
  function fileKey(file) {if(!fileKeys.has(file))fileKeys.set(file,id());return fileKeys.get(file);}
  const database = new Promise((resolve,reject)=>{
    const timer=setTimeout(()=>reject(new Error('Storage did not respond.')),12000);
    const req=indexedDB.open('vinylpac_bulk',2);
    req.onupgradeneeded=()=>{for(const name of ['drafts','files'])if(!req.result.objectStoreNames.contains(name))req.result.createObjectStore(name);};
    req.onerror=()=>{clearTimeout(timer);reject(req.error);};
    req.onblocked=()=>{clearTimeout(timer);reject(new Error('Storage is busy in another tab.'));};
    req.onsuccess=()=>{clearTimeout(timer);req.result.onversionchange=()=>req.result.close();resolve(req.result);};
  });
  function storageAction(mode,run,names='drafts') {
    return database.then(db=>new Promise((resolve,reject)=>{
      let tx,result,failure;
      const timer=setTimeout(()=>{try{tx?.abort();}catch(e){}reject(new Error('Storage did not respond.'));},12000);
      try {
        tx=db.transaction(names,mode);
        const req=run(tx.objectStore(Array.isArray(names)?names[0]:names),tx);
        if(req){req.onsuccess=()=>{result=req.result;};req.onerror=()=>{failure=req.error;};}
        tx.oncomplete=()=>{clearTimeout(timer);resolve(result);};
        tx.onabort=()=>{clearTimeout(timer);reject(failure||tx.error||new Error('Storage is unavailable.'));};
      }catch(error){clearTimeout(timer);reject(error);}
    }));
  }
  function readOrder() {
    return {name:$('customerName').value,email:$('customerEmail').value,rush:$('rush').checked,needBy:$('needBy').value,mockups:$('mockups').checked,instagram:$('instagram').value,
      share:form.querySelector('input[name="share"]:checked')?.value || '',info:$('info').value,terms:$('terms').checked};
  }
  function restoreOrder(o) {
    if (!o) return;
    ['rush','mockups','terms'].forEach((k) => { $(k).checked = !!o[k]; });
    ['needBy','instagram','info'].forEach((k) => { $(k).value = o[k] || ''; });
    if (o.share === 'yes' || o.share === 'no') form.querySelector('input[name="share"][value="'+o.share+'"]').checked = true;
    $('customerName').value=o.name||'';$('customerEmail').value=o.email||'';
    syncRush();
  }
  function draft() {
    return {version:1,rows:rows.map(r=>({...r,file:null,fileKey:r.file?fileKey(r.file):r.fileKey||'',originalFileName:r.file?.name||r.originalFileName||''})),defaults:{...defaults},order:readOrder(),
      meta:rows.map((r) => { const m = metas.get(r.id); const measured = m.measured ? {...m.measured} : null;
        if (measured) delete measured.preview;
        return {id:r.id,anchor:{...m.anchor},measured,measureError:m.measureError || ''}; }),savedAt:Date.now()};
  }
  function storageError(error) {
    console.warn('Bulk draft storage:',error?.name||'',error?.message||'');
    storageFailed = true;
    $('saveStatus').textContent = 'Unable to save on this device. Keep this page open.';
    $('saveStatus').style.whiteSpace = 'normal';
  }
  function persist(immediate) {
    if (!hydrated || stopSaving) return saveChain;
    revision++;
    clearTimeout(saveTimer);
    if (!storageFailed) $('saveStatus').textContent = 'Saving…';
    const write = () => {
      const state=draft(),version=revision;
      const artwork=rows.filter(r=>r.file).map(r=>({key:fileKey(r.file),file:r.file}));
      saveChain=saveChain.catch(()=>{}).then(async()=>{
        for(const {key,file} of artwork) {
          if(savedFiles.has(key))continue;
          const bytes=await file.arrayBuffer();
          await storageAction('readwrite',store=>store.put({bytes,name:file.name,type:file.type,lastModified:file.lastModified},key),'files');
          savedFiles.add(key);
        }
        await storageAction('readwrite',store=>store.put(state,'current'));
        if(version===revision&&!stopSaving){storageFailed=false;$('saveStatus').textContent='Saved on this device';}
      }).catch(storageError);
      return saveChain;
    };
    if (immediate) return write();
    saveTimer = setTimeout(write, 220);
    return saveChain;
  }
  function deleteFiles(submitted,store) {
    const keys=new Set(submitted.map(r=>r.file?fileKey(r.file):r.fileKey).filter(Boolean));
    keys.forEach(key=>{store.delete(key);savedFiles.delete(key);});
  }
  function clearDraft() {
    stopSaving = true; clearTimeout(saveTimer);
    const submitted=rows.slice();
    return saveChain=saveChain.catch(()=>{}).then(()=>storageAction('readwrite',(store,tx)=>{store.delete('current');deleteFiles(submitted,tx.objectStore('files'));},['drafts','files']));
  }
  window.addEventListener('pagehide', () => { if (!stopSaving) persist(true); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden' && !stopSaving) persist(true); });

  // These painters are copied from product-config.js / preview-render.js, without their builder globals.
function drawMaterialSwatch(canvas, matId) {
  var S = canvas.width; // 56
  var ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, S, S);

  if (matId === 'white-vinyl') {
    // Warm white with faint paper gradient and subtle grain
    var g = ctx.createRadialGradient(S*0.35, S*0.35, 0, S*0.5, S*0.5, S*0.72);
    g.addColorStop(0, '#ffffff');
    g.addColorStop(1, '#e8e8e8');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, S, S);
    // Grain dots
    for (var i = 0; i < 90; i++) {
      ctx.beginPath();
      ctx.arc(Math.random()*S, Math.random()*S, Math.random()*0.7+0.1, 0, Math.PI*2);
      ctx.fillStyle = 'rgba(0,0,0,' + (Math.random()*0.04+0.01) + ')';
      ctx.fill();
    }

  } else if (matId === 'clear') {
    // Checkerboard transparency indicator + pale blue edge shimmer
    var tile = 7;
    for (var cy = 0; cy < S; cy += tile) {
      for (var cx = 0; cx < S; cx += tile) {
        ctx.fillStyle = ((Math.floor(cx/tile) + Math.floor(cy/tile)) % 2 === 0)
          ? 'rgba(195,195,195,0.55)' : 'rgba(255,255,255,0.90)';
        ctx.fillRect(cx, cy, tile, tile);
      }
    }
    var eg = ctx.createRadialGradient(S*0.28, S*0.28, 0, S*0.5, S*0.5, S*0.52);
    eg.addColorStop(0, 'rgba(255,255,255,0.45)');
    eg.addColorStop(0.6, 'rgba(200,230,255,0.15)');
    eg.addColorStop(1,   'rgba(160,210,255,0.25)');
    ctx.globalCompositeOperation = 'source-over';
    ctx.fillStyle = eg;
    ctx.fillRect(0, 0, S, S);

  } else if (matId === 'mirror' || matId === 'chrome') {
    // Chrome: diagonal silver gradient + bright specular streak
    var mg = ctx.createLinearGradient(0, 0, S, S);
    mg.addColorStop(0,   '#f5f7f9');
    mg.addColorStop(0.18,'#dce4ec');
    mg.addColorStop(0.38,'#a8b8c8');
    mg.addColorStop(0.55,'#c4d0da');
    mg.addColorStop(0.75,'#e4eaf0');
    mg.addColorStop(1,   '#a0aeb8');
    ctx.fillStyle = mg;
    ctx.fillRect(0, 0, S, S);
    // Specular highlight streak
    var hl = ctx.createLinearGradient(S*0.05, S*0.05, S*0.55, S*0.38);
    hl.addColorStop(0,   'rgba(255,255,255,0.92)');
    hl.addColorStop(0.5, 'rgba(255,255,255,0.30)');
    hl.addColorStop(1,   'rgba(255,255,255,0)');
    ctx.fillStyle = hl;
    ctx.fillRect(0, 0, S, S);
    // Faint secondary reflection at bottom-right
    var hl2 = ctx.createLinearGradient(S*0.6, S*0.7, S, S);
    hl2.addColorStop(0, 'rgba(255,255,255,0)');
    hl2.addColorStop(1, 'rgba(255,255,255,0.35)');
    ctx.fillStyle = hl2;
    ctx.fillRect(0, 0, S, S);

  } else if (matId === 'holo') {
    // Vibrant rainbow diagonal + silver overlay to read as metallic foil
    var hg = ctx.createLinearGradient(0, S, S, 0);
    hg.addColorStop(0,    '#ff6ec7');
    hg.addColorStop(0.18, '#fffb00');
    hg.addColorStop(0.36, '#00ffea');
    hg.addColorStop(0.54, '#a855f7');
    hg.addColorStop(0.72, '#3b82f6');
    hg.addColorStop(0.88, '#ff9de2');
    hg.addColorStop(1,    '#ff6ec7');
    ctx.fillStyle = hg;
    ctx.fillRect(0, 0, S, S);
    // Silver overlay — lighten highlights, deepen troughs → metallic feel
    var sg = ctx.createRadialGradient(S*0.28, S*0.28, 0, S*0.5, S*0.5, S*0.68);
    sg.addColorStop(0, 'rgba(255,255,255,0.55)');
    sg.addColorStop(0.5,'rgba(220,220,220,0.10)');
    sg.addColorStop(1,  'rgba(180,180,180,0.05)');
    ctx.globalCompositeOperation = 'overlay';
    ctx.fillStyle = sg;
    ctx.fillRect(0, 0, S, S);
    ctx.globalCompositeOperation = 'source-over';
    // Tiny sparkle highlights
    for (var hi = 0; hi < 8; hi++) {
      ctx.beginPath();
      ctx.arc(Math.random()*S, Math.random()*S, Math.random()*1.2+0.4, 0, Math.PI*2);
      ctx.fillStyle = 'rgba(255,255,255,0.9)';
      ctx.fill();
    }

  } else if (matId === 'glitter') {
    // A photo of the shop's glitter vinyl (mirror silver under rainbow grains), the jar
    // labels' Glitter swatch too. Silver until it loads.
    ctx.fillStyle = '#a6abb1';
    ctx.fillRect(0, 0, S, S);
    var photo = new Image();
    photo.onload = function() { ctx.drawImage(photo, 0, 0, S, S); };
    photo.src = (window.VP_CDN+"jar-labels__swatch-glitter.jpg?v=40fb8dea88");

  } else if (matId === 'gold') {
    var gg = ctx.createLinearGradient(0, 0, S, S);
    gg.addColorStop(0,   '#fff4c8');
    gg.addColorStop(0.22,'#e8c45a');
    gg.addColorStop(0.48,'#c9952a');
    gg.addColorStop(0.7, '#f0d78a');
    gg.addColorStop(1,   '#a67a1a');
    ctx.fillStyle = gg;
    ctx.fillRect(0, 0, S, S);
    var ghl = ctx.createLinearGradient(S*0.05, S*0.05, S*0.55, S*0.38);
    ghl.addColorStop(0,   'rgba(255,255,240,0.9)');
    ghl.addColorStop(0.5, 'rgba(255,230,140,0.25)');
    ghl.addColorStop(1,   'rgba(255,255,255,0)');
    ctx.fillStyle = ghl;
    ctx.fillRect(0, 0, S, S);

  } else if (matId === 'reflective') {
    var rg = ctx.createLinearGradient(0, 0, S, S);
    rg.addColorStop(0,   '#e9e9e9');
    rg.addColorStop(0.4, '#9c9c9c');
    rg.addColorStop(0.7, '#c8c8c8');
    rg.addColorStop(1,   '#707070');
    ctx.fillStyle = rg;
    ctx.fillRect(0, 0, S, S);
    for (var ri = 0; ri < 90; ri++) {
      ctx.beginPath();
      ctx.arc(Math.random()*S, Math.random()*S, Math.random()*1.4+0.3, 0, Math.PI*2);
      ctx.fillStyle = Math.random() > 0.5
        ? 'rgba(247,247,247,' + (Math.random()*0.8+0.15) + ')'
        : 'rgba(180,220,160,' + (Math.random()*0.5+0.2) + ')';
      ctx.fill();
    }
  }
}
function drawLaminateSwatch(canvas, lamId) {
  if (!canvas || !canvas.getContext) return;
  var S = canvas.width || 44;
  var ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, S, S);
  var seed = 7;
  function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
  function base(c0, c1) {
    var g = ctx.createRadialGradient(S*0.35, S*0.32, 0, S*0.5, S*0.5, S*0.75);
    g.addColorStop(0, c0); g.addColorStop(1, c1);
    ctx.fillStyle = g; ctx.fillRect(0, 0, S, S);
  }
  function specular(alpha, spread) {
    var hl = ctx.createRadialGradient(S*0.30, S*0.26, 0, S*0.30, S*0.26, S*spread);
    hl.addColorStop(0, 'rgba(255,255,255,' + alpha + ')');
    hl.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = hl; ctx.fillRect(0, 0, S, S);
  }
  function sparkle(colors, n, maxR) {
    for (var i = 0; i < n; i++) {
      ctx.beginPath();
      ctx.arc(rnd()*S, rnd()*S, rnd()*maxR + 0.4, 0, Math.PI*2);
      ctx.fillStyle = colors[Math.floor(rnd()*colors.length)];
      ctx.fill();
    }
  }
  function stars(color, n) {
    for (var i = 0; i < n; i++) {
      var x = rnd()*S, y = rnd()*S, r = rnd()*2.2 + 1.2;
      ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI*2);
      ctx.fillStyle = color; ctx.fill();
      ctx.beginPath(); ctx.arc(x, y, r*0.45, 0, Math.PI*2);
      ctx.fillStyle = 'rgba(255,255,255,0.95)'; ctx.fill();
    }
  }
  // Spectrum: soft diagonal rainbow band (transparent holographic film look)
  function rainbowBand(alpha, x0, y0, x1, y1) {
    var rg = ctx.createLinearGradient(x0, y0, x1, y1);
    var hues = ['#ff6b6b', '#ffb84d', '#ffe75c', '#5ee27a', '#4fc3ff', '#7b6bff', '#e06bff'];
    for (var i = 0; i < hues.length; i++) rg.addColorStop(i / (hues.length - 1), hues[i]);
    ctx.globalAlpha = alpha; ctx.fillStyle = rg; ctx.fillRect(0, 0, S, S); ctx.globalAlpha = 1;
  }
  // Spectrum Fracture: crackle web -- seed points joined to their two nearest neighbours
  function crackle(n, light, dark) {
    var pts = [];
    for (var i = 0; i < n; i++) pts.push([rnd()*S, rnd()*S]);
    ctx.lineCap = 'round';
    for (var a = 0; a < n; a++) {
      var d = [];
      for (var b = 0; b < n; b++) if (b !== a) {
        var dx = pts[b][0]-pts[a][0], dy = pts[b][1]-pts[a][1];
        d.push([dx*dx+dy*dy, b]);
      }
      d.sort(function(p, q) { return p[0]-q[0]; });
      for (var k = 0; k < 2 && k < d.length; k++) {
        var p2 = pts[d[k][1]];
        var mx = (pts[a][0]+p2[0])/2 + (rnd()-0.5)*3, my = (pts[a][1]+p2[1])/2 + (rnd()-0.5)*3;
        ctx.beginPath(); ctx.moveTo(pts[a][0], pts[a][1]); ctx.lineTo(mx, my); ctx.lineTo(p2[0], p2[1]);
        ctx.strokeStyle = dark; ctx.lineWidth = 1.6; ctx.stroke();
        ctx.strokeStyle = light; ctx.lineWidth = 0.7; ctx.stroke();
      }
    }
  }
  // Spectrum Hex: honeycomb lattice
  function hexGrid(r, light, dark) {
    var w = Math.sqrt(3)*r, h = 1.5*r;
    for (var row = -1; row * h < S + r; row++) {
      for (var col = -1; col * w < S + w; col++) {
        var cx = col*w + (row % 2 ? w/2 : 0), cy = row*h;
        ctx.beginPath();
        for (var i = 0; i < 6; i++) {
          var ang = Math.PI/6 + i*Math.PI/3;
          var px = cx + r*Math.cos(ang), py = cy + r*Math.sin(ang);
          if (i === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
        }
        ctx.closePath();
        ctx.strokeStyle = dark; ctx.lineWidth = 1.4; ctx.stroke();
        ctx.strokeStyle = light; ctx.lineWidth = 0.6; ctx.stroke();
      }
    }
  }

  if (lamId === 'matte') {
    // Flat warm grey, faint grain, no highlight
    ctx.fillStyle = '#d2d2d2'; ctx.fillRect(0, 0, S, S);
    sparkle(['rgba(0,0,0,0.05)', 'rgba(255,255,255,0.10)'], 120, 0.6);
  } else if (lamId === 'satin') {
    // Soft sheen: warm white with a broad, diffuse diagonal band
    base('#f0f0f0', '#c8c8c8');
    var sb = ctx.createLinearGradient(0, S, S, 0);
    sb.addColorStop(0,    'rgba(255,255,255,0)');
    sb.addColorStop(0.42, 'rgba(255,255,255,0.35)');
    sb.addColorStop(0.58, 'rgba(255,255,255,0.35)');
    sb.addColorStop(1,    'rgba(255,255,255,0)');
    ctx.fillStyle = sb; ctx.fillRect(0, 0, S, S);
    specular(0.25, 0.8);
  } else if (lamId === 'glitter-lam-silver' || lamId === 'glitter-silver') {
    // Sparkle dots on a near-clear base
    base('#f2f4f7', '#c9d0d8');
    sparkle(['rgba(255,255,255,0.9)', 'rgba(205,215,228,0.85)', 'rgba(150,165,180,0.7)'], 110, 1.3);
    stars('rgba(232,238,246,0.95)', 7);
    specular(0.35, 0.7);
  } else if (lamId === 'glitter-lam-stardust' || lamId === 'glitter-stardust') {
    // Stardust: a finer, denser silver sparkle than Apollo Silver
    base('#f3f4f6', '#cdd2d9');
    sparkle(['rgba(255,255,255,0.95)', 'rgba(214,222,232,0.85)', 'rgba(160,172,186,0.7)'], 280, 0.75);
    stars('rgba(240,244,250,0.95)', 4);
    specular(0.3, 0.7);
  } else if (lamId === 'glitter-lam-gold' || lamId === 'glitter-gold') {
    base('#f9efd2', '#d9b866');
    sparkle(['rgba(255,244,200,0.95)', 'rgba(226,178,60,0.9)', 'rgba(170,120,25,0.8)'], 110, 1.3);
    stars('rgba(255,226,120,0.95)', 7);
    specular(0.35, 0.7);
  } else if (lamId === 'glitter-lam-rainbow' || lamId === 'glitter-rainbow') {
    // Galactic Cosmic Shift: holographic colour-shifting flakes
    base('#f4f2f7', '#d3d0dc');
    sparkle(['#ff5fa2', '#ffd23f', '#3ee6c1', '#4f8bff', '#b46bff', '#ff8c42'], 120, 1.3);
    stars('rgba(255,255,255,0.9)', 6);
    specular(0.3, 0.7);
  } else if (lamId === 'glitter-lam-red' || lamId === 'glitter-red') {
    // Galactic Mars Red: red metal flake on a clear (pale pink) base
    base('#fbeeee', '#e3a3a3');
    sparkle(['rgba(255,255,255,0.9)', 'rgba(232,58,58,0.9)', 'rgba(178,24,36,0.85)', 'rgba(255,140,140,0.8)'], 120, 1.3);
    stars('rgba(255,120,120,0.95)', 7);
    specular(0.35, 0.7);
  } else if (lamId === 'glitter-lam-neptune' || lamId === 'glitter-neptune') {
    // Galactic Neptune: cyan / purple flake
    base('#eef4fb', '#b7c3e4');
    sparkle(['rgba(70,220,255,0.9)', 'rgba(150,90,255,0.9)', 'rgba(255,255,255,0.85)', 'rgba(50,130,255,0.75)', 'rgba(200,120,255,0.8)'], 120, 1.3);
    stars('rgba(170,225,255,0.95)', 7);
    specular(0.35, 0.7);
  } else if (lamId === 'holo-lam-fracture' || lamId === 'holo-fracture') {
    // Spectrum Fracture: transparent holo with crackle cells
    base('#f2f2f5', '#c8c9d3');
    rainbowBand(0.55, 0, S*0.15, S, S*0.85);
    crackle(11, 'rgba(255,255,255,0.9)', 'rgba(60,60,80,0.28)');
    specular(0.35, 0.7);
  } else if (lamId === 'holo-lam-prismatic' || lamId === 'holo-prismatic') {
    // Spectrum Prismatic: smooth rainbow bands
    base('#f6f6f8', '#d6d6de');
    rainbowBand(0.78, S*0.1, 0, S*0.9, S);
    specular(0.5, 0.6);
  } else if (lamId === 'holo-lam-cosmic' || lamId === 'holo-cosmic') {
    // Spectrum Super Cosmic: dense holographic flake
    base('#f0f0f4', '#cbcbd6');
    rainbowBand(0.32, 0, S*0.2, S, S*0.8);
    sparkle(['#ff5fa2', '#ffd23f', '#3ee6c1', '#4f8bff', '#b46bff', '#ffffff', '#ff8c42'], 210, 1.0);
    stars('rgba(255,255,255,0.9)', 5);
    specular(0.3, 0.7);
  } else if (lamId === 'holo-lam-hex' || lamId === 'holo-hex') {
    // Spectrum Hex: silver honeycomb cells with a rainbow tint
    base('#f0f0f3', '#c6c7d0');
    rainbowBand(0.45, 0, S*0.2, S, S*0.8);
    hexGrid(4.2, 'rgba(255,255,255,0.85)', 'rgba(70,70,90,0.3)');
    specular(0.35, 0.7);
  } else if (lamId === 'holo-lam-hearts' || lamId === 'holo-hearts') {
    // Clear film on white stock; deeper spectral outlines so the hearts read at chip size.
    ctx.save();
    ctx.beginPath(); ctx.arc(S/2, S/2, S/2, 0, Math.PI*2); ctx.clip();
    base('#fbfbfd', '#e4e7ec');
    ctx.save(); if (S !== 44) ctx.scale(S/44, S/44);
    _paintHeartsField(ctx, 44, 44*1.8, { hues: _HEARTS_CHIP_HUES, lineWidth: 0.8 });
    ctx.restore();
    specular(0.35, 0.6);
    ctx.restore();
  } else {
    // gloss (default): white with a crisp specular highlight
    base('#ffffff', '#c9c9c9');
    specular(0.95, 0.42);
    var gl2 = ctx.createLinearGradient(S*0.55, S*0.65, S, S);
    gl2.addColorStop(0, 'rgba(255,255,255,0)');
    gl2.addColorStop(1, 'rgba(255,255,255,0.55)');
    ctx.fillStyle = gl2; ctx.fillRect(0, 0, S, S);
  }
}

var _HEARTS_TILE_MM = 44;
var _HEARTS_HUES = ['#f39ccc', '#edca76', '#97daba', '#8ecbf0', '#c1a8ed', '#eeb5db'];
var _HEARTS_CHIP_HUES = ['#e2559c', '#d99a1c', '#2fae84', '#2f8fd8', '#8059d2', '#cf4fa6'];
var _HEARTS_OUTLINE = 'M0,-.18 C-.19,-.49 -.50,-.27 -.37,-.02 ' +
  'C-.29,.17 -.11,.40 0,.61 C.11,.40 .29,.17 .37,-.02 ' +
  'C.50,-.27 .19,-.49 0,-.18 Z';

function _traceLaminateHeart(tc, x, y, r) {
  tc.beginPath();
  tc.moveTo(x, y - r*0.18);
  tc.bezierCurveTo(x - r*0.19, y - r*0.49, x - r*0.50, y - r*0.27, x - r*0.37, y - r*0.02);
  tc.bezierCurveTo(x - r*0.29, y + r*0.17, x - r*0.11, y + r*0.40, x, y + r*0.61);
  tc.bezierCurveTo(x + r*0.11, y + r*0.40, x + r*0.29, y + r*0.17, x + r*0.37, y - r*0.02);
  tc.bezierCurveTo(x + r*0.50, y - r*0.27, x + r*0.19, y - r*0.49, x, y - r*0.18);
  tc.closePath();
}

function _heartPatternNoise(col, row, salt) {
  var n = ((col*37 + row*101 + salt*17 + 8192) % 997 + 997) % 997;
  return ((n*n*13 + n*53 + 17) % 997) / 997;
}

var _heartsLaminateMotifs = null;
function _heartLaminateMotifs() {
  if (_heartsLaminateMotifs) return _heartsLaminateMotifs;
  var motifs = [];
  [
    { cells: 2, salt: 11, min: 6.8, max: 10.2 },
    { cells: 5, salt: 37, min: 2.6, max: 4.4 },
    { cells: 10, salt: 71, min: 1.0, max: 1.8 }
  ].forEach(function(layer, level) {
    var cell = _HEARTS_TILE_MM / layer.cells;
    for (var row = 0; row < layer.cells; row++) {
      for (var col = 0; col < layer.cells; col++) {
        var n = function(salt) { return _heartPatternNoise(col, row, layer.salt + salt); };
        if (level > 0 && n(3) < (level === 1 ? 0.18 : 0.12)) continue;
        var kind = 'heart', choice = n(19);
        if (level === 2) kind = choice < 0.42 ? 'heart' : choice < 0.64 ? 'ring' :
          choice < 0.85 ? 'halo' : choice < 0.95 ? 'chip' : 'dot';
        motifs.push({
          kind: kind, level: level,
          x: (col + 0.5 + (n(5) - 0.5)*0.48)*cell,
          y: (row + 0.5 + (n(7) - 0.5)*0.48)*cell,
          size: layer.min + n(11)*(layer.max - layer.min),
          angle: (n(13) - 0.5)*(kind === 'heart' ? 0.12 : 0.8),
          nested: kind === 'heart' && level < 2 && n(29) > (level === 0 ? 0.70 : 0.90),
          hue: Math.floor(n(17)*_HEARTS_HUES.length),
          alpha: 0.65 + n(23)*0.35
        });
      }
    }
  });
  var spaced = [];
  motifs.forEach(function(m) {
    var overlap = spaced.some(function(large) {
      if (large.kind !== 'heart' || large.level >= m.level) return false;
      var dx = m.x - large.x, dy = m.y - large.y - large.size*0.08;
      dx -= Math.round(dx/_HEARTS_TILE_MM)*_HEARTS_TILE_MM;
      dy -= Math.round(dy/_HEARTS_TILE_MM)*_HEARTS_TILE_MM;
      var rx = large.size*0.40 + m.size*0.25;
      var ry = large.size*0.50 + m.size*0.25;
      return dx*dx/(rx*rx) + dy*dy/(ry*ry) < 1;
    });
    if (!overlap) spaced.push(m);
  });
  _heartsLaminateMotifs = spaced;
  return spaced;
}

function _heartAccentPath(kind) {
  return kind === 'heart' ? _HEARTS_OUTLINE : 'M-.16,-.16 L.16,-.16 L.16,.16 L-.16,.16 Z';
}

function _heartsLaminateRepeat(S) {
  var dims = typeof vpGetCurrentDims === 'function' ? vpGetCurrentDims() : { w: 3, h: 3 };
  return S * _HEARTS_TILE_MM / (Math.max(Number(dims.w) || 3, Number(dims.h) || 3)*25.4);
}

function _paintHeartsField(tc, S, repeat, opts) {
  repeat = repeat || _heartsLaminateRepeat(S);
  var hues = (opts && opts.hues) || _HEARTS_HUES;
  var scale = repeat / _HEARTS_TILE_MM;
  var motifs = _heartLaminateMotifs();
  tc.save();
  tc.lineJoin = tc.lineCap = 'round';
  // Wrapped copies retain complete outlines at a tile boundary.
  for (var row = -1; row*repeat < S + repeat; row++) {
    for (var col = -1; col*repeat < S + repeat; col++) {
      motifs.forEach(function(m) {
        var x = col*repeat + m.x*scale, y = row*repeat + m.y*scale, size = m.size*scale;
        if (x + size < 0 || y + size < 0 || x - size > S || y - size > S) return;
        tc.save(); tc.translate(x, y); tc.rotate(m.angle);
        var rg = tc.createLinearGradient(-size*0.45, -size*0.35, size*0.45, size*0.5);
        rg.addColorStop(0, hues[m.hue]);
        rg.addColorStop(1, hues[(m.hue + 1) % hues.length]);
        tc.strokeStyle = tc.fillStyle = rg;
        tc.globalAlpha = m.alpha;
        tc.lineWidth = (opts && opts.lineWidth) || Math.max(S <= 44 ? 0.55 : 0.24, scale*0.12);
        if (m.kind === 'heart') _traceLaminateHeart(tc, 0, 0, size);
        else if (m.kind === 'ring' || m.kind === 'dot') {
          tc.beginPath(); tc.arc(0, 0, size*(m.kind === 'dot' ? 0.14 : 0.36), 0, Math.PI*2);
        } else if (m.kind === 'chip') {
          tc.beginPath(); tc.rect(-size*0.16, -size*0.16, size*0.32, size*0.32);
        } else {
          tc.setLineDash([size*0.18, size*0.1734]);
          tc.beginPath(); tc.arc(0, 0, size*0.45, 0, Math.PI*2); tc.stroke();
          tc.setLineDash([]);
          tc.beginPath(); tc.arc(0, 0, size*0.28, 0, Math.PI*2);
        }
        if (m.kind === 'dot' || m.kind === 'chip') tc.fill(); else tc.stroke();
        if (m.nested) {
          _traceLaminateHeart(tc, 0, size*0.08, size*0.36); tc.stroke();
        }
        tc.restore();
      });
    }
  }
  tc.restore();
}

  const swatches = new Map();
  function swatch(kind,key) {
    const cacheKey=kind+'|'+key;if(swatches.has(cacheKey))return swatches.get(cacheKey);
    const patches={'glitter-lam-silver':'glitter-silver','glitter-lam-gold':'glitter-gold','glitter-lam-rainbow':'glitter-rainbow'};
    let url;
    if(kind==='material'&&key==='glitter')url=(window.VP_CDN+"jar-labels__swatch-glitter.jpg?v=40fb8dea88");
    else if(kind==='laminate'&&patches[key])url=(window.VP_CDN+"laminate-swatches__")+patches[key]+'.png';
    else {const c=document.createElement('canvas');c.width=c.height=kind==='material'?56:['glitter-lam-stardust','holo-lam-hearts'].includes(key)?96:44;(kind==='material'?drawMaterialSwatch:drawLaminateSwatch)(c,key);url=c.toDataURL();}
    swatches.set(cacheKey,url);return url;
  }
  const collections={material:C.MATERIALS,laminate:C.LAMINATES,cut:C.CUTS,whiteInk:C.WHITE_INK,side:[{id:'h',label:'Tall'},{id:'w',label:'Wide'}]};
  function picker(kind, value, label, onChange, blank) {
    const key=id(), wrap=document.createElement('div');wrap.className='bo-picker';
    wrap.dataset.picker=key;
    wrap.innerHTML='<button type="button" class="bo-trigger" role="combobox" aria-haspopup="listbox" aria-expanded="false" aria-controls="'+key+'" aria-label="'+esc(label)+'"><span class="bo-trigger-text"></span><i class="bo-chevron" aria-hidden="true"></i></button><div class="bo-options'+(['cut','side','whiteInk'].includes(kind)?' bo-options-simple':'')+'" id="'+key+'" role="listbox" aria-label="'+esc(label)+'" hidden></div>';
    const trigger=wrap.firstElementChild, panel=wrap.lastElementChild;
    const api={kind,value,label,wrap,trigger,panel,onChange,blank};pickerRegistry.set(key,api);
    const options=blank?[{id:'',label:blank},...collections[kind]]:collections[kind];
    let group='', grid;
    options.forEach((option)=>{
      if(!grid || (option.group||'')!==group) {
        group=option.group||'';
        if(group){const title=document.createElement('p');title.className='bo-option-group';title.textContent=group;panel.append(title);}
        grid=document.createElement('div');grid.className='bo-option-grid';panel.append(grid);
      }
      const b=document.createElement('button');b.type='button';b.className='bo-option';b.setAttribute('role','option');b.dataset.value=option.id;b.tabIndex=-1;if(option.cuts)b.dataset.cuts=option.cuts.join(' ');
      if(option.id && (kind==='material'||kind==='laminate')) b.innerHTML='<img class="bo-swatch" src="'+swatch(kind,option.id)+'" alt="" width="34" height="34">';
      const text=document.createElement('span');text.textContent=option.label;b.append(text);grid.append(b);
      b.addEventListener('click',()=>{api.value=option.id;updatePicker(api);closePicker(true);onChange(option.id);});
    });
    trigger.id=key+'-trigger';
    trigger.addEventListener('click',()=>pickerOpen===api?closePicker(false):openPicker(api));
    trigger.addEventListener('keydown',(e)=>{if(['ArrowDown','ArrowUp','Home','End'].includes(e.key)){e.preventDefault();openPicker(api);const options=[...panel.querySelectorAll('[role="option"]:not([hidden])')];(e.key==='End'?options.at(-1):options.find((n)=>n.dataset.value===api.value)||options[0])?.focus();}});
    panel.addEventListener('keydown',(e)=>{
      const all=[...panel.querySelectorAll('[role="option"]:not([hidden])')], current=all.indexOf(document.activeElement);let n=current;
      if(['ArrowDown','ArrowRight'].includes(e.key))n=(current+1)%all.length;
      else if(['ArrowUp','ArrowLeft'].includes(e.key))n=(current+all.length-1)%all.length;
      else if(e.key==='Home')n=0;else if(e.key==='End')n=all.length-1;
      else if(e.key==='Escape'){e.preventDefault();closePicker(true);return;}else if(e.key==='Tab'){closePicker(false);return;}else return;
      e.preventDefault();all[n]?.focus();
    });
    updatePicker(api);return api;
  }
  function updatePicker(api) {
    const opt=collections[api.kind].find((o)=>o.id===api.value);
    const valueText=opt?.label||api.blank||'Choose';
    // A long option keeps its full name in the list and for screen readers; the closed field shows its short name
    // ("Kiss cut" for "Kiss cut + transfer tape") so it never clips.
    api.trigger.querySelector('.bo-trigger-text').textContent=opt?.short||valueText;
    api.trigger.setAttribute('aria-label',api.label+': '+valueText);
    api.trigger.querySelector('.bo-swatch')?.remove();
    if(opt && ['material','laminate'].includes(api.kind)){const img=new Image();img.className='bo-swatch';img.alt='';img.src=swatch(api.kind,opt.id);api.trigger.prepend(img);}
    api.panel.querySelectorAll('[role="option"]').forEach((b)=>b.setAttribute('aria-selected',String(b.dataset.value===api.value)));
  }
  // Stardust is die cut only (Josh 10/18): a laminate picker shows it only while the cut is Die cut.
  function lamCuts(api,cut){api.panel.querySelectorAll('[data-cuts]').forEach((b)=>{b.hidden=!b.dataset.cuts.split(' ').includes(cut);});}
  function positionPicker(api) {
    api.panel.style.left='0px';
    const rect=api.panel.getBoundingClientRect(), max=document.documentElement.clientWidth-16;
    const shift=rect.right>max?max-rect.right:rect.left<16?16-rect.left:0;
    api.panel.style.left=shift+'px';
  }
  function openPicker(api) {
    closePicker(false);pickerOpen=api;api.panel.hidden=false;api.trigger.setAttribute('aria-expanded','true');positionPicker(api);
    api.wrap.closest('.bo-row,.bo-toolbar')?.classList.add('has-picker');
  }
  function closePicker(focus) {
    if(!pickerOpen)return;const api=pickerOpen;pickerOpen=null;api.panel.hidden=true;api.trigger.setAttribute('aria-expanded','false');api.wrap.closest('.bo-row,.bo-toolbar')?.classList.remove('has-picker');if(focus)api.trigger.focus({preventScroll:true});
  }
  document.addEventListener('pointerdown',(e)=>{if(pickerOpen&&!pickerOpen.wrap.contains(e.target))closePicker(false);});
  document.addEventListener('keydown',(e)=>{if(e.key==='Escape')closePicker(true);});
  window.addEventListener('resize',()=>{if(pickerOpen)positionPicker(pickerOpen);});
  function field(title, control) {
    const f=document.createElement('div');f.className='bo-field';const l=document.createElement('label');l.className='bo-label';l.textContent=title;const target=control.matches('input,textarea,button')?control:control.querySelector('input,button');if(target){if(!target.id)target.id=id();l.htmlFor=target.id;}f.append(l,control);return f;
  }
  function input(label, value, attrs) {
    const el=document.createElement('input');el.className='bo-input';el.id=id();el.type='text';el.inputMode='decimal';el.autocomplete='off';el.setAttribute('aria-label',label);el.value=value||'';
    Object.entries(attrs||{}).forEach(([k,v])=>el.setAttribute(k,v));return el;
  }
  const setPickers={};
  ['material','laminate','cut'].forEach((key)=>{
    const p=picker(key,'','Set all '+key,(v)=>{defaults[key]=v;syncSetLam();persist();},'No change');setPickers[key]=p;
    $('setAllFields').append(field(key[0].toUpperCase()+key.slice(1),p.wrap));
  });
  // Set all: Stardust shows once Cut is set to Die cut; moving the cut off Die cut clears it to "No change".
  function syncSetLam(){const p=setPickers.laminate;if(defaults.laminate&&!C.lamAllowed(defaults.laminate,defaults.cut)){defaults.laminate='';p.value='';updatePicker(p);}lamCuts(p,defaults.cut);}
  syncSetLam();
  const setSize=document.createElement('div');setSize.className='bo-size-inputs';
  const setValue=input('Set all size in inches','',{placeholder:'Inches','data-set':'size',maxlength:7});
  const setSide=picker('side','h','Set all size direction',(v)=>{defaults.side=v;persist();});
  setSize.append(setValue,setSide.wrap);$('setAllFields').append(field('Size (in)',setSize));
  const setQty=input('Set all quantity','',{placeholder:'Min 10',inputmode:'numeric','data-set':'qty',maxlength:7});$('setAllFields').append(field('Qty',setQty));
  setValue.addEventListener('input',()=>{defaults.value=setValue.value;persist();});setQty.addEventListener('input',()=>{defaults.qty=setQty.value;persist();});

  function newMeta(saved) {
    return {anchor:saved?.anchor||{side:'h',value:''},measured:saved?.measured||null,measureError:saved?.measureError||'',
      measuring:false,measureVersion:0,quoteVersion:0,price:null,pricePending:false,node:null,pickers:{},visible:false};
  }
  function createRow(file, filename) {
    const r={id:id(),fileName:(file?file.name:filename||'').replace(/\.[^.]+$/,''),file:file||null,material:defaults.material||'white-vinyl',laminate:defaults.laminate||'gloss',cut:defaults.cut||'kiss',h:'',w:'',qty:defaults.qty||'',whiteInk:'none',whiteWhere:'',notes:''};
    const m=newMeta();m.anchor={side:defaults.side,value:defaults.value};
    if(Number(defaults.value)>0)r[defaults.side]=num(defaults.value);
    rows.push(r);metas.set(r.id,m);appendRow(r);if(file)queueMeasure(r);else schedulePrice(r);return r;
  }
  function sizeControl(r) {
    const m=metas.get(r.id), host=m.node.querySelector('.bo-row-size');
    if(pickerOpen&&host.contains(pickerOpen.wrap))closePicker(false);
    host.querySelectorAll('[data-picker]').forEach((n)=>pickerRegistry.delete(n.dataset.picker));
    host.replaceChildren();
    const fit=!!(m.measured?.aspect>0);
    if(fit){
      const line=document.createElement('div');line.className='bo-size-inputs';
      const v=input('Design size in inches',m.anchor.value,{placeholder:'Inches','data-field':'anchor',maxlength:7});
      const p=picker('side',m.anchor.side,'Size direction',(side)=>{m.anchor.side=side;fitRow(r);refreshSize(r);schedulePrice(r);persist();});m.pickers.side=p;
      line.append(v,p.wrap);host.append(line);
    }else{
      const line=document.createElement('div');line.className='bo-size-manual';
      ['w','h'].forEach((key,i)=>{if(i){const t=document.createElement('span');t.className='bo-times';t.textContent='×';line.append(t);}const l=document.createElement('label');const v=input(key==='w'?'Width in inches':'Height in inches',num(r[key]),{placeholder:key==='w'?'W':'H','data-field':key,maxlength:7});const unit=document.createElement('span');unit.className='bo-unit';unit.textContent='″';l.append(v,unit);line.append(l);});host.append(line);
    }
    const help=document.createElement('p');help.className='bo-size-help';host.append(help);const sizeLabel=host.parentElement.querySelector('.bo-label');if(sizeLabel)sizeLabel.htmlFor=host.querySelector('input').id;refreshSize(r);
  }
  function fitRow(r) {
    const m=metas.get(r.id);
    if(m.measured?.aspect>0){const fit=Number.isFinite(Number(m.anchor.value))?C.fitSize(m.anchor,m.measured.aspect):null;r.w=fit?fit.w:'';r.h=fit?fit.h:'';}
  }
  function refreshSize(r) {
    const m=metas.get(r.id), help=m.node.querySelector('.bo-size-help');if(!help)return;
    if(m.measuring)help.textContent='Reading your art’s shape…';
    else if(r.w>0&&r.h>0&&m.measured?.aspect>0)help.innerHTML='<strong>'+num(r.w)+'″ × '+num(r.h)+'″</strong><span class="bo-matched">Matched to your art</span>';
    else if(m.measured?.aspect>0)help.textContent='One side — we’ll fit the other.';
    else help.textContent='Width × height, in inches.';
  }
  function appendRow(r) {
    $('bulkEmpty')?.remove();list.querySelector('.bo-empty')?.remove();
    const m=metas.get(r.id),node=document.createElement('div');m.node=node;node.className='bo-row';node.id=r.id;node.dataset.row=r.id;node.setAttribute('role','row');node.setAttribute('aria-label',r.fileName||'Sticker design');
    node.innerHTML='<div class="bo-row-head bo-cell" role="cell"><button type="button" class="bo-art" data-action="art" aria-label="'+esc('Attach or replace artwork for '+(r.fileName||'this design'))+'">'+artIcon+'</button><div class="bo-name"><label class="bo-name-label" for="name-'+r.id+'">Design <span class="bo-row-number"></span></label><input class="bo-input" id="name-'+r.id+'" data-field="fileName" type="text" maxlength="200" placeholder="Design name" value="'+esc(r.fileName)+'"><p class="bo-file-caption"></p></div></div><div class="bo-material-cell bo-cell" role="cell"></div><div class="bo-laminate-cell bo-cell" role="cell"><div class="bo-finish" aria-label="Finish preview loading"><span class="bo-finish-status">…</span></div></div><div class="bo-cut-cell bo-cell" role="cell"></div><div class="bo-size-cell bo-cell" role="cell"><label class="bo-label">Size (in)</label><div class="bo-row-size"></div></div><div class="bo-qty-cell bo-cell" role="cell"></div><div class="bo-note-cell bo-cell" role="cell"><label class="bo-label" for="notes-'+r.id+'">Notes</label><input class="bo-input" id="notes-'+r.id+'" data-field="notes" maxlength="750" placeholder="Optional notes" value="'+esc(r.notes)+'"><input class="bo-input bo-ink-where" id="where-'+r.id+'" type="text" data-field="whiteWhere" maxlength="180" placeholder="Where should the white go?" aria-label="Where should the white go?" value="'+esc(r.whiteWhere)+'" hidden><p class="bo-row-message" role="status"></p></div><div class="bo-row-price bo-cell" role="cell"><strong class="bo-line-total">—</strong><span class="bo-each">Size + qty</span></div><div class="bo-row-actions bo-cell" role="cell"><button type="button" data-action="duplicate" title="Duplicate design" aria-label="Duplicate design"><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><rect x="7" y="7" width="10" height="10" rx="2"/><path d="M4 13H3V3h10v1"/></svg></button><button type="button" data-action="remove" title="Remove design" aria-label="Remove design"><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="m5 5 10 10M15 5 5 15"/></svg></button></div>';
    ['material','laminate','cut'].forEach((key)=>{
      const p=picker(key,r[key],key[0].toUpperCase()+key.slice(1)+' for '+(r.fileName||'this design'),(v)=>{r[key]=v;syncLam(r);syncInk(r);requestFinish(r);schedulePrice(r);persist();});m.pickers[key]=p;
      const cell=node.querySelector('.bo-'+key+'-cell'),label=document.createElement('label');label.className='bo-label';label.textContent=key[0].toUpperCase()+key.slice(1);label.htmlFor=p.trigger.id;cell.prepend(label);cell.append(p.wrap);
    });
    const ink=document.createElement('div');ink.className='bo-ink';ink.innerHTML='<span class="bo-ink-prefix">White ink:</span><div class="bo-ink-choice"></div>';
    const p=picker('whiteInk',r.whiteInk,'White ink',(v)=>{r.whiteInk=v;syncInk(r);showRowMessage(r);persist();});m.pickers.whiteInk=p;ink.lastElementChild.append(p.wrap);node.querySelector('.bo-material-cell').append(ink);
    const qty=input('Quantity for '+(r.fileName||'this design'),r.qty,{placeholder:'Min '+C.minQty(r),inputmode:'numeric','data-field':'qty',maxlength:7});node.querySelector('.bo-qty-cell').append(field('Qty',qty));
    list.append(node);sizeControl(r);syncArt(r);syncLam(r);syncInk(r);showRowMessage(r);observer.observe(node);return node;
  }
  // A row's cut moving off Die cut drops Stardust to Gloss (also fixes rows saved before it was die cut only).
  function syncLam(r) {
    const p=metas.get(r.id).pickers.laminate;
    if(!C.lamAllowed(r.laminate,r.cut)){r.laminate='gloss';p.value=r.laminate;updatePicker(p);}
    lamCuts(p,r.cut);
  }
  function syncArt(r) {
    const m=metas.get(r.id), button=m.node.querySelector('.bo-art');
    if(m.measured?.thumb){const img=new Image();img.src=m.measured.thumb;img.alt='Artwork for '+(r.fileName||'this design');button.replaceChildren(img);}
    else if(m.measuring)button.innerHTML='<span class="bo-art-text">Reading<br>art…</span>';
    else if(r.file)button.innerHTML='<span class="bo-art-text">'+esc(r.file.name.split('.').pop().toUpperCase())+'<br>Replace</span>';
    else button.innerHTML=artIcon;
    button.setAttribute('aria-label','Attach or replace artwork for '+(r.fileName||'this design'));
    m.node.querySelector('.bo-file-caption').textContent=r.file?r.file.name:r.missingFile?'Re-attach this file':'Attach art now, or send it later';
  }
  function syncInk(r) {
    const m=metas.get(r.id),white=!!C.MATERIALS.find(v=>v.id===r.material)?.white,spot=white&&r.whiteInk==='spot';
    m.node.querySelector('.bo-ink').classList.toggle('is-visible',white);
    m.pickers.whiteInk.trigger.disabled=!white;
    const where=m.node.querySelector('[data-field="whiteWhere"]'),notes=m.node.querySelector('[data-field="notes"]');where.hidden=!spot;where.required=spot;notes.hidden=spot;
    const label=m.node.querySelector('.bo-note-cell>.bo-label');label.textContent=spot?'White placement':'Notes';label.htmlFor=(spot?where:notes).id;
    if(!spot)where.removeAttribute('aria-invalid');
  }
  function showRowMessage(r) {
    const m=metas.get(r.id), target=m.node.querySelector('.bo-row-message');
    const problem=C.rowProblem(r), fileError=r.missingFile?problem:'', quoteError=m.price&&!m.price.ok&&!problem?m.price.message:'';
    // An entered quantity under this finish's minimum (10 plain, 20 specialty) says so at once, not only at checkout.
    const underMin=Number(r.qty)>0&&Number(r.qty)<C.minQty(r)?problem:'';
    target.classList.toggle('is-error',!!(fileError||checked&&problem||quoteError||underMin||m.measureError));
    target.textContent=fileError||(checked&&problem?problem:quoteError||underMin||m.measureError||'');
  }
  function counts() {
    $('designCount').textContent=rows.length+' / '+C.MAX_ROWS;
    $('addRowBottom').hidden=rows.length<3;
    list.querySelectorAll('.bo-row-number').forEach((el,i)=>el.textContent=String(i+1).padStart(2,'0'));
    if(!rows.length&&!list.querySelector('.bo-empty'))list.innerHTML='<div class="bo-empty" id="bulkEmpty"><strong>Your next order starts here.</strong>Upload a batch of files, or add a design and attach the art later.</div>';
    $('addRow').disabled=rows.length>=C.MAX_ROWS;$('addRowBottom').disabled=rows.length>=C.MAX_ROWS;
    updateSummary();
  }
  const observer=new IntersectionObserver((entries)=>entries.forEach((entry)=>{const r=rows.find((r)=>r.id===entry.target.dataset.row);if(!r)return;metas.get(r.id).visible=entry.isIntersecting;if(entry.isIntersecting)requestFinish(r);}),{rootMargin:'180px 0px'});

  // Read two files at a time to keep phones responsive, even for large batches.
  function queueMeasure(r) {
    const m=metas.get(r.id);m.measureVersion++;m.measuring=true;m.measureError='';m.measured=null;
    measureQueue.push({id:r.id,file:r.file,version:m.measureVersion});syncArt(r);refreshSize(r);showRowMessage(r);pumpMeasure();
  }
  function pumpMeasure() {
    while(measuring<2&&measureQueue.length){
      const job=measureQueue.shift(), r=rows.find((r)=>r.id===job.id), m=metas.get(job.id);
      if(!r||m.measureVersion!==job.version)continue;
      measuring++;
      C.measure(job.file).then((result)=>{
        if(!metas.has(job.id)||m.measureVersion!==job.version)return;
        m.measured=result;m.measuring=false;
        if(result.aspect>0){if(!(Number(m.anchor.value)>0)){const side=r.h>0?'h':r.w>0?'w':m.anchor.side;m.anchor={side,value:r[side]||''};}fitRow(r);}
        sizeControl(r);syncArt(r);showRowMessage(r);schedulePrice(r);persist();
      }).catch(()=>{
        if(!metas.has(job.id)||m.measureVersion!==job.version)return;
        m.measuring=false;m.measureError='Couldn’t read the art’s shape. Enter both dimensions.';sizeControl(r);syncArt(r);showRowMessage(r);schedulePrice(r);persist();
      }).finally(()=>{measuring--;pumpMeasure();updateSummary();});
    }
  }
  function showUpload(message,error) {$('uploadMessage').textContent=message;$('uploadMessage').classList.toggle('is-error',!!error);}
  async function receiveFiles(files,targetId) {
    const incoming=Array.from(files||[]);
    await ready;
    if(checkingOut)return;
    const accepted=[],errors=[];
    incoming.forEach((file)=>{const a=C.accepts(file);if(a.ok||a.later)accepted.push({file,later:!!a.later});if(!a.ok)errors.push(file.name+': '+a.message);});
    let attached=0,added=0;
    const target=targetId&&rows.find((r)=>r.id===targetId);
    if(target&&accepted.length){const {file,later}=accepted.shift(),m=metas.get(target.id);target.file=later?null:file;delete target.missingFile;delete target.fileKey;delete target.originalFileName;target.fileName=file.name.replace(/\.[^.]+$/,'');m.node.querySelector('[data-field="fileName"]').value=target.fileName;
      if(later){m.measureVersion++;m.measuring=false;m.measured=null;m.measureError='';sizeControl(target);syncArt(target);showRowMessage(target);schedulePrice(target);}else queueMeasure(target);attached++;}
    accepted.forEach(({file,later})=>{if(rows.length>=C.MAX_ROWS){errors.push(file.name+': One order can hold up to '+C.MAX_ROWS+' designs.');return;}createRow(later?null:file,file.name);added++;});
    const done=[added?added+' design'+(added===1?'':'s')+' added':'',attached?'Artwork replaced':''].filter(Boolean).join('. ');
    if(added||attached)$('cartAdded').hidden=true;
    if(window.VPArtUpload)rows.forEach(r=>{if(r.file)window.VPArtUpload.bulkFile(r.file);});/* theme: art up now (vp-art.js) */
    showUpload((done?done+'. ':'')+errors.join(' '),errors.length>0);counts();persist(true);
  }
  $('browseFiles').addEventListener('click',()=>$('bulkFiles').click());
  $('bulkFiles').addEventListener('change',(e)=>{receiveFiles(e.target.files);e.target.value='';});
  $('rowFile').addEventListener('change',(e)=>{receiveFiles(e.target.files,rowFileTarget);e.target.value='';});
  function fileDrag(e){return Array.from(e.dataTransfer?.types||[]).includes('Files');}
  let dragDepth=0;
  document.addEventListener('dragenter',(e)=>{if(!fileDrag(e))return;e.preventDefault();dragDepth++;document.body.classList.add('is-dragging');e.target.closest?.('.bo-row')?.classList.add('is-dragover');});
  document.addEventListener('dragover',(e)=>{if(!fileDrag(e))return;e.preventDefault();e.dataTransfer.dropEffect='copy';});
  document.addEventListener('dragleave',(e)=>{if(!fileDrag(e))return;dragDepth=Math.max(0,dragDepth-1);if(!dragDepth)document.body.classList.remove('is-dragging');const row=e.target.closest?.('.bo-row');if(row&&!row.contains(e.relatedTarget))row.classList.remove('is-dragover');});
  document.addEventListener('drop',(e)=>{if(!fileDrag(e))return;e.preventDefault();dragDepth=0;document.body.classList.remove('is-dragging');document.querySelectorAll('.is-dragover').forEach((n)=>n.classList.remove('is-dragover'));receiveFiles(e.dataTransfer.files,e.target.closest?.('.bo-row')?.dataset.row);});

  function addBlank() {if(!hydrated||checkingOut)return;if(rows.length>=C.MAX_ROWS){showUpload('One order can hold up to '+C.MAX_ROWS+' designs.',true);return;}const r=createRow();$('cartAdded').hidden=true;counts();persist(true);metas.get(r.id).node.querySelector('[data-field="fileName"]').focus({preventScroll:true});metas.get(r.id).node.scrollIntoView({block:'nearest',behavior:'smooth'});}
  $('addRow').addEventListener('click',addBlank);$('addRowBottom').addEventListener('click',addBlank);
  list.addEventListener('click',(e)=>{
    const action=e.target.closest('[data-action]')?.dataset.action,node=e.target.closest('[data-row]');if(!action||!node||checkingOut)return;
    const r=rows.find((r)=>r.id===node.dataset.row),m=metas.get(r.id);
    if(action==='art'){rowFileTarget=r.id;$('rowFile').click();}
    else if(action==='remove'){
      closePicker(false);observer.unobserve(node);node.querySelectorAll('[data-picker]').forEach((n)=>pickerRegistry.delete(n.dataset.picker));clearTimeout(priceTimers.get(r.id));const index=rows.indexOf(r);rows.splice(index,1);metas.delete(r.id);node.remove();counts();persist(true);(metas.get(rows[Math.min(index,rows.length-1)]?.id)?.node.querySelector('[data-field="fileName"]')||$('addRow')).focus({preventScroll:true});
    }else if(action==='duplicate'){
      if(rows.length>=C.MAX_ROWS){showUpload('One order can hold up to '+C.MAX_ROWS+' designs.',true);return;}
      const copy={...r,id:id()},cm=newMeta({anchor:{...m.anchor},measured:m.measured,measureError:m.measureError});rows.splice(rows.indexOf(r)+1,0,copy);metas.set(copy.id,cm);appendRow(copy);node.after(cm.node);if(m.measuring)queueMeasure(copy);schedulePrice(copy);counts();persist(true);
    }
  });
  list.addEventListener('input',(e)=>{
    const key=e.target.dataset.field,node=e.target.closest('[data-row]');if(!key||!node)return;
    const r=rows.find((r)=>r.id===node.dataset.row),m=metas.get(r.id);e.target.removeAttribute('aria-invalid');
    if(key==='anchor'){m.anchor.value=e.target.value;fitRow(r);refreshSize(r);schedulePrice(r);}
    else if(key==='w'||key==='h'){r[key]=e.target.value;m.anchor={side:key,value:e.target.value};refreshSize(r);schedulePrice(r);}
    else {r[key]=e.target.value;if(key==='qty')schedulePrice(r);if(key==='fileName')node.setAttribute('aria-label',r.fileName||'Sticker design');}
    showRowMessage(r);persist();
  });
  list.addEventListener('change',(e)=>{const key=e.target.dataset.field;if(!['anchor','w','h'].includes(key))return;const r=rows.find((r)=>r.id===e.target.closest('[data-row]')?.dataset.row);if(!r)return;const m=metas.get(r.id);if(Number(e.target.value)>0){e.target.value=num(e.target.value);if(key==='anchor'){m.anchor.value=e.target.value;fitRow(r);}else{r[key]=e.target.value;m.anchor.value=e.target.value;}refreshSize(r);schedulePrice(r);persist();}});
  $('applyAll').addEventListener('click',()=>{
    if(!hydrated||checkingOut)return;
    if(defaults.value&&(!(Number(defaults.value)>0)||!Number.isFinite(Number(defaults.value)))){$('setAllMessage').textContent='Enter a size greater than zero.';setValue.setAttribute('aria-invalid','true');setValue.focus();return;}
    const setMin=defaults.material||defaults.laminate?C.minQty({material:defaults.material||'white-vinyl',laminate:defaults.laminate||'gloss'}):C.MIN_QTY;
    if(defaults.qty&&(!Number.isSafeInteger(Number(defaults.qty))||Number(defaults.qty)<setMin)){$('setAllMessage').textContent=setMin>C.MIN_QTY?'Minimum '+setMin+' for specialty finishes.':'Minimum '+setMin+' per design.';setQty.setAttribute('aria-invalid','true');setQty.focus();return;}
    setValue.removeAttribute('aria-invalid');setQty.removeAttribute('aria-invalid');
    rows.forEach((r)=>{
      const m=metas.get(r.id);
      ['material','laminate','cut'].forEach((k)=>{if(defaults[k]){r[k]=defaults[k];m.pickers[k].value=r[k];updatePicker(m.pickers[k]);}});syncLam(r);
      if(defaults.qty){r.qty=defaults.qty;m.node.querySelector('[data-field="qty"]').value=r.qty;}
      if(Number(defaults.value)>0){m.anchor={side:defaults.side,value:num(defaults.value)};if(m.measured?.aspect>0)fitRow(r);else{r[defaults.side]=num(defaults.value);r[defaults.side==='h'?'w':'h']='';}sizeControl(r);}
      syncInk(r);requestFinish(r);schedulePrice(r);showRowMessage(r);
    });
    $('setAllMessage').textContent=rows.length?'Applied to '+rows.length+' design'+(rows.length===1?'':'s')+'. New designs use these settings.':'Settings saved for your next designs.';persist(true);
  });

  // Quotes are versioned so a slower old response cannot overwrite a newer selection.
  function schedulePrice(r) {
    const m=metas.get(r.id);if(!m)return;
    const qtyInput=m.node.querySelector('[data-field="qty"]');if(qtyInput)qtyInput.placeholder='Min '+C.minQty(r);   // 10 plain, 20 specialty
    clearTimeout(priceTimers.get(r.id));m.quoteVersion++;m.price=null;m.pricePending=true;paintPrice(r);updateSummary();
    const version=m.quoteVersion;
    priceTimers.set(r.id,setTimeout(async()=>{
      const result=await C.quote({...r});if(!metas.has(r.id)||m.quoteVersion!==version)return;
      m.price=result;m.pricePending=false;paintPrice(r);showRowMessage(r);updateSummary();
    },280));
  }
  function paintPrice(r) {
    const m=metas.get(r.id), total=m.node.querySelector('.bo-line-total'),each=m.node.querySelector('.bo-each');
    if(m.price?.ok){total.textContent=money(m.price.totalCents);each.textContent=money(Math.round(m.price.each*100))+' /sticker';}
    else{total.textContent='—';each.textContent=m.pricePending?'Updating…':(Number(r.qty)>0&&Number(r.qty)<C.minQty(r)?'Min '+C.minQty(r):'Size + qty');}
  }
  let wholeTotal=0;
  function updateSummary() {
    const products=rows.reduce((sum,r)=>sum+(metas.get(r.id)?.price?.ok?metas.get(r.id).price.totalCents:0),0);
    const qty=rows.reduce((sum,r)=>sum+(Number.isSafeInteger(Number(r.qty))&&Number(r.qty)>0?Number(r.qty):0),0);
    const pending=rows.filter((r)=>metas.get(r.id)?.pricePending||metas.get(r.id)?.measuring).length;
    const unpriced=rows.filter((r)=>!metas.get(r.id)?.price?.ok).length;
    const needsDetails=rows.filter((r)=>!!C.rowProblem(r)).length;
    const others=C.otherCartItems(),otherCents=C.otherCartCents(),rush=$('rush').checked?C.rushCents(products+otherCents):0;
    wholeTotal=products+otherCents+rush;
    $('summaryDesigns').textContent=rows.length;$('summaryQty').textContent=qty.toLocaleString('en-US');$('summaryProducts').textContent=money(products);
    $('otherTotalLine').hidden=!others.length;$('summaryOther').textContent=money(otherCents);$('rushTotalLine').hidden=!rush;$('summaryRush').textContent=money(rush);
    $('summaryTotal').textContent=money(wholeTotal);$('mobileTotal').textContent=money(wholeTotal);$('mobileCount').textContent=!rows.length&&others.length?'In your cart':rows.length+' design'+(rows.length===1?'':'s')+' · '+(unpriced?'Priced so far':'Total');
    $('rushFee').textContent='Rush fee: '+money(C.rushCents(products+otherCents));
    // Josh 10/29: no designs on the form (and none it added earlier): its Check out has nothing to send, so no amount.
    if(!checkingOut)$('bulkCheckout').textContent=rows.length||C.formCartLines()?'Check out · '+money(wholeTotal):'Check out';
    $('summaryStatus').textContent=pending?'Updating sizes and prices…':needsDetails?needsDetails+' design'+(needsDetails===1?' needs':'s need')+' details. Total includes priced items.':unpriced?'Some designs couldn’t be priced. Check the message on each design.':!rows.length?(C.formCartLines()?'Your earlier designs are in your cart. Add more, or check out.':'Add a design to get started.'):'All designs priced. Ready when you are.';
    $('otherItems').hidden=!others.length;
    $('otherItemsList').replaceChildren(...others.map((it)=>{const li=document.createElement('li'),name=document.createElement('span'),amount=document.createElement('span');name.textContent=(it.qty||'')+' × '+(it.name||'Cart item');amount.textContent=money(Math.round(Number(it.total||0)*100));li.append(name,amount);return li;}));
  }
  window.addEventListener('storage',updateSummary);window.addEventListener('focus',updateSummary);
  // The shared drawer can remove a builder item while this page remains open.
  document.addEventListener('click',(e)=>{if(e.target.closest('.cart-item-remove,.cart-btn-clear'))setTimeout(updateSummary,0);});

  // ONE off-screen VPQuote3D scene. Cache one small snapshot for each finish combination.
  const finishCache=new Map(),finishJobs=new Map();let renderChain=Promise.resolve(),rendererPromise;
  function renderer() {
    if(rendererPromise)return rendererPromise;
    rendererPromise=(async()=>{
      // Loaded like the builder does (sticker-preview-3d.js): a module script tag. The Shopify build rewrites a plain
      // 'quote-3d.js' string, but not a dynamic import() (it broke this whole file on the draft theme).
      if(!window.VPQuote3D)await new Promise((resolve,reject)=>{const s=document.createElement('script');s.type='module';s.src=(window.VP_CDN+"quote-3d.js?v=38bc3b7040");s.async=true;s.setAttribute('noshim','');
        s.onload=()=>window.VPQuote3D?resolve():reject(new Error('3D unavailable'));s.onerror=()=>reject(new Error('3D unavailable'));document.head.appendChild(s);});
      const stage=document.createElement('div');stage.className='bo-render-stage';stage.setAttribute('aria-hidden','true');
      const canvas=document.createElement('canvas');canvas.width=240;canvas.height=200;stage.append(canvas);document.body.append(stage);
      await window.VPQuote3D.mount(canvas);await waitReady();return window.VPQuote3D;
    })();
    return rendererPromise;
  }
  function waitReady() {return new Promise((resolve,reject)=>{const start=performance.now();function check(){if(window.VPQuote3D?.ready())resolve();else if(performance.now()-start>20000)reject(new Error('Finish preview unavailable'));else setTimeout(check,50);}check();});}
  function requestFinish(r) {
    const m=metas.get(r.id);if(!m||!m.visible)return;
    const key=[r.material,r.laminate,r.cut].join('|');m.finishKey=key;
    const host=m.node.querySelector('.bo-finish');
    function display(url){if(!metas.has(r.id)||m.finishKey!==key)return;let img=host.querySelector('img');if(!img){img=new Image();img.alt='';img.width=100;img.height=86;host.prepend(img);}img.src=url;host.querySelector('.bo-finish-status').textContent='';host.setAttribute('aria-label',C.MATERIALS.find(v=>v.id===r.material)?.label+' with '+C.LAMINATES.find(v=>v.id===r.laminate)?.label+', finish sample');}
    if(finishCache.has(key)){display(finishCache.get(key));return;}
    host.querySelector('img')?.remove();host.querySelector('.bo-finish-status').textContent='…';
    if(!finishJobs.has(key)){
      const payload=C.render3d(r);
      const job=renderChain.catch(()=>{}).then(async()=>{
        const api=await renderer();api.set(payload);await waitReady();api.look(.72,-.12);
        await new Promise(resolve=>setTimeout(resolve,120));const url=api.snapshot();if(!url)throw new Error('No finish sample');finishCache.set(key,url);return url;
      });
      renderChain=job;finishJobs.set(key,job);
      job.catch(()=>{finishJobs.delete(key);});
    }
    finishJobs.get(key).then(display).catch(()=>{if(m.finishKey===key&&metas.has(r.id))host.querySelector('.bo-finish-status').textContent='Preview unavailable';});
  }

  function syncRush() {const on=$('rush').checked;$('needByWrap').classList.toggle('is-visible',on);$('needBy').disabled=!on;$('needBy').required=on;$('needBy').min=today();}
  form.addEventListener('input',(e)=>{if(!checkingOut)$('checkoutError').textContent='';if(e.target.closest('.bo-end,.bo-contact')){e.target.removeAttribute('aria-invalid');if(e.target.id==='rush')syncRush();persist();updateSummary();}});
  function focusError(el) {el.setAttribute('aria-invalid','true');el.focus({preventScroll:true});el.closest('.bo-row,.bo-end,.bo-contact')?.scrollIntoView({behavior:'smooth',block:'start'});}
  function orderError(o) {
    const orderProblem=C.orderProblem(o);
    if(orderProblem){$('checkoutError').textContent=orderProblem;focusError(!o.name.trim()?$('customerName'):!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(o.email.trim())?$('customerEmail'):!o.terms?$('terms'):$('needBy'));return true;}
    if(o.rush&&(!/^\d{4}-\d{2}-\d{2}$/.test(o.needBy)||o.needBy<today()||!$('needBy').validity.valid)){$('checkoutError').textContent='Choose a need-by date of today or later.';focusError($('needBy'));return true;}
    return false;
  }
  // After Add to cart the designs live in the cart: the rows go, the Set all choices and the order details stay
  // (as the sticker builder keeps its options and clears the art, Josh 10/15).
  function clearDesigns(submitted=rows.slice()) {
    closePicker(false);
    submitted.forEach((r)=>{const m=metas.get(r.id);clearTimeout(priceTimers.get(r.id));if(m?.node){observer.unobserve(m.node);m.node.querySelectorAll('[data-picker]').forEach((n)=>pickerRegistry.delete(n.dataset.picker));}metas.delete(r.id);m?.node?.remove();});
    rows=rows.filter(r=>!submitted.includes(r));measureQueue=measureQueue.filter(job=>metas.has(job.id));checked=false;showUpload('');counts();
    clearTimeout(saveTimer);
    saveChain=saveChain.catch(()=>{}).then(()=>storageAction('readwrite',(store)=>deleteFiles(submitted,store),'files')).catch(()=>{});
    return persist(true);
  }
  function freezeCheckout(button,mode) {
    const disabled=[...form.querySelectorAll('input,textarea,button')].map(el=>({el,was:el.disabled}));
    checkingOut=true;disabled.forEach(({el})=>{el.disabled=true;});
    button.innerHTML='<span class="bo-spin" aria-hidden="true"></span><span>'+(mode==='cart'?'Adding to cart…':'Taking you to checkout…')+'</span>';
    unfreezeCheckout=()=>{checkingOut=false;stopSaving=false;disabled.forEach(({el,was})=>{el.disabled=was;});$('bulkAddCart').textContent='Add to cart';unfreezeCheckout=null;updateSummary();};
  }
  window.addEventListener('pageshow',async(event)=>{
    if(!event.persisted)return;
    await ready;
    if(unfreezeCheckout)unfreezeCheckout();
    checkingOut=false;stopSaving=false;
    // The cart owns committed designs, just as after Add to cart. Keep any rows it does not own.
    const committed=new Set(C.cartRowIds()),submitted=rows.filter(r=>committed.has(r.id));
    if(submitted.length)await clearDesigns(submitted);
    if(committed.size||!rows.length)C.releaseSession();
    updateSummary();persist(true);
  });
  // Josh 10/17: "i want them to be able to either add to cart or instant check out".
  async function placeOrder(mode) {
    if(!hydrated||checkingOut)return;closePicker(false);$('checkoutError').textContent='';$('cartAdded').hidden=true;
    const o=readOrder();
    // Every design was added to the cart earlier: Check out takes that cart to checkout.
    if(!rows.length&&mode==='checkout'&&C.formCartLines()){
      if(orderError(o))return;
      freezeCheckout($('bulkCheckout'),'checkout');
      try{await persist(true);await C.checkoutCart(o);}catch(error){unfreezeCheckout();$('checkoutError').textContent=error?.message||'Couldn’t continue to checkout. Please try again.';updateSummary();}
      return;
    }
    checked=true;
    for(let i=0;i<rows.length;i++){
      const r=rows[i],m=metas.get(r.id);showRowMessage(r);const problem=C.rowProblem(r);
      if(problem){$('checkoutError').textContent='Design '+(i+1)+': '+problem;const key=/white goes/.test(problem)?'whiteWhere':/quantity|Minimum/.test(problem)?'qty':!(r.w>0&&r.h>0)?(m.measured?.aspect?'anchor':!(r.w>0)?'w':'h'):'fileName';focusError(r.missingFile?m.node.querySelector('[data-action="art"]'):m.node.querySelector('[data-field="'+key+'"]')||m.node.querySelector('input'));return;}
      if(m.measuring){$('checkoutError').textContent='Please wait while we measure your artwork.';return;}
    }
    if(!rows.length){$('checkoutError').textContent='Add at least one design.';$('addRow').focus();return;}
    if(orderError(o))return;
    const button=mode==='cart'?$('bulkAddCart'):$('bulkCheckout');
    // Keep the original disabled states for errors and Back from checkout.
    freezeCheckout(button,mode);
    try {
      await persist(true);
      const measured=Object.fromEntries(rows.map(r=>[r.id,metas.get(r.id).measured]));
      if(mode==='cart'){
        const added=await C.addToCart(rows.map(r=>({...r})),o,measured);
        unfreezeCheckout();await clearDesigns();
        $('cartAddedText').textContent=added+' design'+(added===1?'':'s')+' added to your cart.';$('cartAdded').hidden=false;
        return;
      }
      await C.checkout(rows.map(r=>({...r})),o,measured);
      await clearDraft();
    }catch(error){
      if(unfreezeCheckout)unfreezeCheckout();$('checkoutError').textContent=error?.message||(mode==='cart'?'Couldn’t add to your cart. Please try again.':'Couldn’t continue to checkout. Please try again.');updateSummary();
    }
  }
  form.addEventListener('submit',(e)=>{e.preventDefault();placeOrder('checkout');});
  $('bulkAddCart').addEventListener('click',()=>placeOrder('cart'));
  $('viewCart').addEventListener('click',()=>{if(typeof window.openCartDrawer==='function')window.openCartDrawer();else location.href="/?view=configurator&openCart=1";});
  const ready=(async()=>{
    let reconciled=false;
    try{
      const saved=await storageAction('readonly',(s)=>s.get('current'));
      list.replaceChildren();
      if(saved?.version===1&&Array.isArray(saved.rows)){
        defaults={...defaults,...saved.defaults};
        Object.entries(setPickers).forEach(([k,p])=>{p.value=defaults[k];updatePicker(p);});syncSetLam();setValue.value=defaults.value;setQty.value=defaults.qty;setSide.value=defaults.side;updatePicker(setSide);
        restoreOrder(saved.order);
        const committed=new Set(C.cartRowIds());
        if(committed.size){C.releaseSession();reconciled=true;}
        for(const item of saved.rows.slice(0,C.MAX_ROWS).filter(r=>!committed.has(String(r.id)))){
          const r={...item,id:String(item.id||id())};
          if(item.fileKey){
            try{
              const art=await storageAction('readonly',store=>store.get(item.fileKey),'files');
              if(!art?.bytes)throw new Error('Saved artwork could not be opened.');
              r.file=new File([art.bytes],art.name||item.originalFileName||'artwork.png',{type:art.type||'',lastModified:art.lastModified||0});fileKeys.set(r.file,item.fileKey);savedFiles.add(item.fileKey);delete r.missingFile;delete r.originalFileName;delete r.fileKey;
            }catch(error){r.file=null;r.missingFile=true;storageError(error);}
          }
          if(r.file&&!(r.file instanceof File)&&r.file instanceof Blob)r.file=new File([r.file],item.originalFileName||r.fileName||'artwork.png',{type:r.file.type});
          if(r.file&&!(r.file instanceof Blob))r.file=null;
          const m=newMeta(saved.meta?.find(v=>v.id===r.id));rows.push(r);metas.set(r.id,m);appendRow(r);
          if(r.file&&!m.measured)queueMeasure(r);schedulePrice(r);
        }
        if(!storageFailed)$('saveStatus').textContent=rows.length?'Saved form restored · '+rows.length+' design'+(rows.length===1?'':'s'):'Saved on this device';
      }else $('saveStatus').textContent='Your work saves on this device';
    }catch(error){list.replaceChildren();storageError();}
    if(!rows.length)C.releaseSession();
    if(window.VPArtUpload)rows.forEach(r=>{if(r.file)window.VPArtUpload.bulkFile(r.file);});/* theme: art up now (vp-art.js) */
    hydrated=true;list.setAttribute('aria-busy','false');$('bulkCheckout').disabled=false;$('bulkAddCart').disabled=false;syncRush();counts();if(reconciled)persist(true);
  })();
})();
